import { createContext } from "react";

import { CurrentUser } from "@/types/user.types";

export type CurrentUserContextValueType = {
  currentUser: CurrentUser | null;
  loading: boolean;
  refetch: () => Promise<unknown>;
  isError: boolean;
};

export const CurrentUserContext = createContext<CurrentUserContextValueType>({
  currentUser: null,
  loading: false,
  refetch: () => Promise.resolve(),
  isError: false,
});
